module.exports = __webpack_public_path__ + "img/age-title.9dd77c55.png";